import React from 'react';
import PropTypes from 'prop-types';

import classes from './LandingMenuItems.css';
import LandingMenuItem from './LandingMenuItems/LandingMenuItem';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const landingMenuItems = props => {
  const { language } = props;
  return (
    <ul className={classes.LandingMenuItems}>
      <LandingMenuItem
        toPage="/motor-data"
        menuItemTitle={LocalizedStrings[language].motorData}
        menuItemDesc={LocalizedStrings[language].motorDataDesc}
      />
    </ul>
  );
};

landingMenuItems.propTypes = {
  language: PropTypes.string.isRequired
};

export default landingMenuItems;
